/*
 * Konami-JS ~
 * :: Now with support for touch events and multiple instances for
 * :: those situations that call for multiple easter eggs!
 * Code: https://github.com/snaptortoise/konami-js
 * Copyright (c) 2009 George Mandis (georgemandis.com, snaptortoise.com)
 * Version: 1.6.0 (1/3/2018)
 * Licensed under the MIT License (http://opensource.org/licenses/MIT)
 * Tested in: Safari 4+, Google Chrome 4+, Firefox 3+, IE7+, Mobile Safari 2.2.1+ and Android
 */

var Konami = function (pattern, callback) {
	if (typeof pattern === 'function') {
		callback = pattern;
		pattern = null;
	}

	if (Array.isArray(pattern)) {
		pattern = pattern.join('');
	}

	var konami = {
		addEvent: function (obj, type, fn) {
			obj.addEventListener(type, fn, false);
		},
		removeEvent: function (obj, eventName, eventCallback) {
			obj.removeEventListener(eventName, eventCallback);
		},
		input: '',
		pattern: pattern || '38384040373937396665',
		keydownHandler: function (e, refObj) {
			if (refObj) {
				konami = refObj;
			} // IE
			konami.input += e.keyCode;
			if (konami.input.length > konami.pattern.length) {
				konami.input = konami.input.substr(konami.input.length - konami.pattern.length);
			}

			if (konami.input === konami.pattern) {
				konami.code(this._currentLink);
				konami.input = '';
				e.preventDefault();
				return false;
			}
		},
		load: function () {
			this.addEvent(document, 'keydown', this.keydownHandler, this);
		},
		unload: function () {
			this.removeEvent(document, 'keydown', this.keydownHandler);
		},
		code: function (link) {
			window.location = link;
		}
	};

	konami.code = callback;
	konami.load();

	return konami;
};

window.Konami = Konami;
module.exports = Konami;
